(() => {
  'use strict';
  const FORM_ID = '168428';
  function initVideos(root) {
    root.querySelectorAll('[data-catering-video]').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      const toggle = video.parentElement.querySelector('[data-video-toggle]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let manualPause = false;
      const load = () => {
        const source = video.querySelector('source[data-src]');
        if (!source.src) { source.src = source.dataset.src; video.load(); }
      };
      const update = () => {
        toggle.textContent = video.paused ? '再生' : '一時停止';
        toggle.setAttribute('aria-label', video.paused ? '動画を再生' : '動画を一時停止');
      };
      const play = () => { load(); video.muted = true; video.play().catch(update); };
      toggle.addEventListener('click', () => {
        if (video.paused) { manualPause = false; play(); }
        else { manualPause = true; video.pause(); }
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { toggle.textContent = '動画を再読み込み'; });
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting && !reduced.matches && !manualPause) play();
          else video.pause();
        }
      }, { threshold: 0.1 });
      observer.observe(video);
    });
  }
  function enhance(container) {
    const root = container?.closest('[data-fam-catering]');
    const form = container?.matches('form') ? container : container?.querySelector(`form[data-id="${FORM_ID}"]`);
    if (!root || !form || form.dataset.famEnhanced) return;
    const host = root.querySelector('[data-catering-form-host]');
    const template = root.querySelector('[data-catering-form-template]');
    if (!host || !template) return;
    const mapping = { organization:'text-1', name:'text', email:'email', message:'textarea', scenario:'select-1', timing:'select-2', meals:'select-3', budget:'select-4', region:'text-2' };
    const native = {};
    for (const id of [...Object.values(mapping), 'radio-1', 'consent-1']) {
      native[id] = form.querySelector(`.globo-form-control[data-element-id="${id}"]`);
      if (!native[id]) return; // Keep the native app form usable if its structure changes.
    }
    const fragment = template.content.cloneNode(true);
    const errors = wrap => [...wrap.querySelectorAll('.messages')];
    for (const [key,id] of Object.entries(mapping)) {
      const wrap = native[id];
      const field = fragment.querySelector(`#${key}`).closest('.field');
      const placeholder = field.querySelector('input,select,textarea');
      const input = wrap.querySelector('input,select,textarea');
      const nativeLabel = wrap.querySelector('label');
      const messages = errors(wrap);
      input.classList.add('fam-input');
      input.required = key !== 'message';
      if (key === 'organization') input.autocomplete = 'organization';
      if (key === 'name') input.autocomplete = 'name';
      if (key === 'email') input.autocomplete = 'email';
      if (key === 'message') { input.rows = 4; input.maxLength = 2000; }
      field.querySelector('label').htmlFor = input.id;
      field.querySelector('label').classList.add('globo-label');
      field.querySelector('label').dataset.label = nativeLabel?.dataset.label || field.querySelector('label').textContent;
      if (nativeLabel?.id) field.querySelector('label').id = nativeLabel.id;
      placeholder.replaceWith(input);
      wrap.classList.add('field','fam-field');
      wrap.replaceChildren(...field.childNodes, ...messages);
      field.replaceWith(wrap);
    }
    const radio = native['radio-1'];
    const fieldset = fragment.querySelector('.service-field');
    const radioErrors = errors(radio);
    fieldset.querySelector('legend').dataset.label = '希望する提供方法';
    fieldset.querySelector('legend').id = '168428-radio-1-label';
    fieldset.querySelectorAll('input').forEach(placeholder => {
      const input = [...radio.querySelectorAll('input[type=radio]')].find(el => el.value === placeholder.value);
      if (input) { input.required = true; placeholder.replaceWith(input); }
    });
    fieldset.replaceWith(radio);
    radio.replaceChildren(fieldset,...radioErrors);
    const consent = native['consent-1'];
    const consentLabel = fragment.querySelector('.consent-row');
    const consentInput = consent.querySelector('input');
    const consentErrors = errors(consent);
    consentInput.required = true;
    consentLabel.dataset.label = '個人情報の利用目的に同意する';
    consentLabel.querySelector('input').replaceWith(consentInput);
    consentLabel.replaceWith(consent);
    consent.replaceChildren(consentLabel,...consentErrors);
    // Retain the app's original named controls and transport. Only the presentation changes.
    const hidden = [...form.querySelectorAll('.globo-form-control[data-type=hidden]')];
    const metadata = [...form.children].filter(el => el.matches('input[type=hidden]'));
    const errorSummary = form.querySelector('.gfb__error-summary');
    const errorMessage = form.querySelector('.message.error');
    const successMessage = form.querySelector('.message.success');
    const block = document.createElement('div');
    block.className = 'block-container'; block.dataset.id = FORM_ID;
    block.append(fragment,...hidden);
    form.replaceChildren(...[errorSummary,block,errorMessage,successMessage,...metadata].filter(Boolean));
    form.classList.add('fam-enhanced');
    form.dataset.famEnhanced = 'true';
    const submit = form.querySelector('[type=submit]');
    submit.classList.add('action','submit');
    const label = submit.querySelector('[data-submit-label]');
    const status = form.querySelector('.submit-status');
    const first = form.querySelector('[data-step="1"]');
    const second = form.querySelector('[data-step="2"]');
    const back = form.querySelector('[data-back]');
    let step = 1, busy = false;
    function show(number, focus = true) {
      step = number;
      first.hidden = number !== 1; second.hidden = number !== 2;
      form.querySelectorAll('.form-progress li').forEach((li,i) => {
        li.classList.toggle('current',i+1===number); li.classList.toggle('complete',i+1<number);
        if(i+1===number) li.setAttribute('aria-current','step'); else li.removeAttribute('aria-current');
      });
      if(number===2) form.querySelector('[data-summary]').textContent = [
        radio.querySelector('input:checked')?.value,
        ...['select-1','select-2','select-3','text-2','select-4'].map(id=>native[id].querySelector('input,select').value)
      ].filter(Boolean).join(' ／ ');
      if(focus) {
        (number===1?first:second).querySelector('h3').focus({preventScroll:true});
        host.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    function valid(panel) {
      for(const input of panel.querySelectorAll('input,select,textarea')) {
        input.setCustomValidity(input.required && input.type==='text' && !input.value.trim() ? 'この項目をご入力ください。' : '');
        if(!input.checkValidity()) { input.reportValidity(); return false; }
      }
      return true;
    }
    form.querySelectorAll('input,select,textarea').forEach(input=>input.addEventListener('input',()=>input.setCustomValidity('')));
    form.querySelector('[data-next]').addEventListener('click',()=>{if(valid(first))show(2);});
    back.addEventListener('click',()=>{if(!busy)show(1);});
    form.addEventListener('keydown',event=>{
      if(event.key==='Enter' && step===1 && event.target.matches('input')) {event.preventDefault();if(valid(first))show(2);}
    });
    form.addEventListener('submit',event=>{
      if(busy) {event.preventDefault();event.stopImmediatePropagation();return;}
      if(!valid(first)) {show(1);event.preventDefault();event.stopImmediatePropagation();return;}
      if(!valid(second)) {show(2,false);event.preventDefault();event.stopImmediatePropagation();}
    },true);
    function setBusy(value) {
      busy=value;submit.disabled=value;back.disabled=value;
      submit.setAttribute('aria-busy',String(value));
      label.textContent=value?'送信しています…':'この内容で相談する';
      status.textContent=value?'ご相談内容を送信しています。このままお待ちください。':'';
    }
    document.addEventListener('globo.formbuilder.form.submitting',event=>{
      if(event.detail?.form===form)setBusy(true);
    });
    document.addEventListener('globo.formbuilder.form.submitted',event=>{
      if(event.detail?.form===form)setBusy(false);
    });
    // App removes loading on both successful responses and transport failures.
    // Observe that actual state instead of inventing a successful response after a timer.
    new MutationObserver(()=>{
      if(busy && !submit.classList.contains('loading')) {
        setBusy(false);
        if(errorMessage && getComputedStyle(errorMessage).display!=='none') {
          status.textContent='送信できませんでした。入力内容を確認し、時間をおいてもう一度お試しください。';
          errorMessage.focus();
        }
      }
    }).observe(submit,{attributes:true,attributeFilter:['class']});
    if(errorMessage) errorMessage.dataset.otherError='送信できませんでした。時間をおいてもう一度お試しください。';
    host.querySelector('[data-form-loading]')?.remove();
    host.querySelector('[data-form-fallback]').hidden=true;
    show(1,false);
  }
  function init(root) {
    initVideos(root);
    const host = root.querySelector('[data-catering-form-host]');
    if(host) {
      setTimeout(()=>{if(!host.querySelector('.fam-enhanced'))host.querySelector('[data-form-fallback]').hidden=false;},12000);
      const loaded = window.Globo?.FormBuilder?.loadedForms?.[FORM_ID];
      if(loaded)enhance(loaded);
    }
  }
  document.addEventListener('globo.formbuilder.form.loaded',event=>{
    if(String(event.detail?.formId)===FORM_ID)enhance(event.detail.form);
  });
  document.querySelectorAll('[data-fam-catering]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-fam-catering]').forEach(init));
})();
